import {
  ArrayPath,
  FieldArray,
  FieldArrayWithId,
  FieldValues,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFieldArraySwap,
  UseFieldArrayUpdate,
  UseFormReturn,
} from "react-hook-form";
import { RiMenuAddFill } from "react-icons/ri";
import { Button } from "../ui/Button";
import SelectPointDDL from "./SelectPointDDL";
import { FormLabel, FormMessage } from "../ui/Form";
import { DndContext, DragEndEvent } from "@dnd-kit/core";
import { SortableContext } from "@dnd-kit/sortable";

export default function PointsSelector<T extends FieldValues>({
  form,
  fields,
  defaultFieldObject,
  append,
  remove,
  swap,
  update,
}: {
  defaultFieldObject: FieldArray<T, ArrayPath<T>>;
  form: UseFormReturn<T>;
  fields: FieldArrayWithId<T, ArrayPath<T>, "id">[];
  append: UseFieldArrayAppend<T, ArrayPath<T>>;
  remove: UseFieldArrayRemove;
  swap: UseFieldArraySwap;
  update: UseFieldArrayUpdate<T, ArrayPath<T>>;
}) {
  const onDragEndHandler = (e: DragEndEvent) => {
    console.log("onDragEndHandler", e);
    const { active, over } = e;
    if (over && active.id !== over.id) {
      const oldIndex = fields.findIndex((f) => f.id === active.id);
      const newIndex = fields.findIndex((f) => f.id === over.id);
      swap(oldIndex, newIndex);
    }
  };
  return (
    <>
      <div className="mt-3">
        <FormLabel>Trip Points</FormLabel>
      </div>
      <DndContext autoScroll={false} onDragEnd={onDragEndHandler}>
        <SortableContext items={fields}>
          {fields.map((field, i) => {
            return (
              <SelectPointDDL
                key={i}
                fieldsLength={fields.length}
                fieldObject={field}
                form={form}
                index={i}
                removeItem={remove}
                update={update}
              />
            );
          })}
        </SortableContext>
      </DndContext>
      <FormMessage>
        {/* @ts-ignore */}
        {form.formState.errors?.points?.message
          ? (form.formState.errors?.points?.message as string)
          : form.formState.errors?.points?.root &&
              "message" in form.formState.errors?.points?.root
            ? form.formState.errors?.points?.root?.message
            : ""}
      </FormMessage>
      <Button
        type="button"
        onClick={() => {
          append(defaultFieldObject);
        }}
      >
        <RiMenuAddFill />
      </Button>
    </>
  );
}
